import Util from "../../lib/util.js";
import { client, gql } from "../../GraphQL.svelte";

// TODO: refactor the stuff from that module into model classes like this
import { allProjectFields, addAllProjectFields, allTemplateFields } from "../../Participaid.svelte";

let ProjectField = {};

ProjectField.getFieldInputType = function(typeField) {
  if (!typeField) {
    // nothing
  }
  else if (typeField.name.toLowerCase().includes("time") ||
          (typeField.formulaType && ["YEAR_SALARY", "HOUR_RATE"].includes(typeField.formulaType.type))) {
    return "time";
  }
  else {
    return "currency";
  }
};

ProjectField.getFormulaTypes = async function() {
  let response = await allTemplateFields();
  let map = {};
  response.data.templateFields.forEach(field => {
    if (field.formulaType) {
      map[field.formulaType.type] = field.formulaType;
    }
  });
  return map;
};

ProjectField.isTimeType = function(str) {
  return str && str.toLowerCase() == "time";
};

ProjectField.isCurrencyType = function(str) {
  return str && str.toLowerCase() == "currency";
};

ProjectField.isTimeField = function(typeField) {
  return ProjectField.isTimeType( ProjectField.getFieldInputType(typeField) );
};

ProjectField.isCurrencyField = function(typeField) {
  return ProjectField.isCurrencyType( ProjectField.getFieldInputType(typeField) );
};

ProjectField.isMetaField = function(field) {
  return field && field.name && (field.name.startsWith("__") && field.name.endsWith("__"))
};

ProjectField.isMetaFieldType = function(field, name) {
  return ProjectField.isMetaField(field)
    && name.toLowerCase() == field
                              .name
                              .substring(2, field.name.length-2)
                              .toLowerCase()
                              ;
};

ProjectField.isHourlyRateField = function(field) {
  return field && field.formulaType.type == "HOUR_RATE";
};

ProjectField.clean = function(field) {
  if (field) {
    let newField = {...field};
    delete newField.id;
    return Util.filterObjectProp(newField, "__typename");
  }
};

ProjectField.destroy = function(projectId, fieldId) {
  return client.mutate({
      mutation: gql`
        mutation($id: Guid!, $projectId: Guid!) {
            deleteProjectField(id: $id, projectId: $projectId) {
                id
            }
        }
      `,
      variables: {
          projectId, id: fieldId
      }
  });
};

ProjectField.all = function(projectId) {
  return allProjectFields(projectId).then(res =>
    res.data.projectFields
  )
};

ProjectField.deleteAll = function(projectId) {
  return allProjectFields(projectId)
    .then(res => Promise.all(res.data.projectFields.map(field => {
      return ProjectField.destroy(projectId, field.id)
    })));
};

ProjectField.add = function(projectId, field) {
  return addAllProjectFields(projectId, [field])
};

ProjectField.overwriteAll = function(projectId, newFields) {
  return ProjectField.deleteAll(projectId)
    .then(res =>
      addAllProjectFields(projectId, newFields.map(field =>
        ProjectField.clean(field)
      ))
    );
};

export default ProjectField;